import { Component, OnInit, inject } from '@angular/core';
import { ImageManager } from 'src/app/shared/image-manager';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from "../../../services/auth/auth.service";
import { Router, RouterLink } from "@angular/router";
import { Filter } from 'src/app/shared/object/filter';
import { FilterService } from 'src/app/services/filter.service';
import { XploreItemService } from 'src/app/services/xplore-item.service';
import { MenuDropdownComponent } from '../menu-dropdown/menu-dropdown.component';
import { toSignal } from '@angular/core/rxjs-interop';

import { SearchInputComponent } from '../../pages/search-page/search-input/search-input.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [
    RouterLink,
    SearchInputComponent,
    MenuDropdownComponent,
    TranslateModule
]
})
export class HeaderComponent implements OnInit {

  filters: Filter[] = [];
  loadedIndex = 0;
  isSearchPage: boolean = false;


  protected readonly ImageManager = ImageManager;

  flagIcon: string;
  private translation = inject(TranslateService);
  private authService = inject(AuthService);
  private xploreItemService = inject(XploreItemService);
  private router = inject(Router);
  private filterService = inject(FilterService);
  readonly isUserLogged = toSignal(this.authService.isUserLogged(), { initialValue: false });

  constructor() {
    this.filters = this.filterService.getFilters();
  }

  ngOnInit(): void {
    this.updateFlagIcon(this.translation.currentLang);

    this.router.events.subscribe(() => {
      this.isSearchPage = this.router.url.includes('/search');
    });
  }

  toggleLanguage(): void {
    const selectedLanguage = this.translation.currentLang === 'it' ? 'en' : 'it'
    this.changeLanguage(selectedLanguage)
  }

  changeLanguage(language: string): void {
    this.translation.use(language);
    this.updateFlagIcon(language);
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }

  updateFlagIcon(currentLang: string): void {
    this.flagIcon = currentLang === 'it' ? ImageManager.italianFlagIcon : ImageManager.englishFlagIcon;
  }

  // Backward-compatible bridge for cached templates still calling isUserFullyLogged().
  isUserFullyLogged(): boolean {
    return this.isUserLogged();
  }

  searchClicked(inputText: string) {
    if(inputText === '') {
      this.router.navigate(['search']);
    } else {
      this.router.navigate(['search'], { queryParams: { name: inputText } });
    }
  }
}
